import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeTest: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Booking = {
  __typename?: 'Booking';
  details?: Maybe<Array<BookingDetail>>;
  guests?: Maybe<Array<Guest>>;
  id: Scalars['ID']['output'];
  leadGuest?: Maybe<Guest>;
};

export type BookingDetail = {
  __typename?: 'BookingDetail';
  id: Scalars['ID']['output'];
  productPrice?: Maybe<ProductPrice>;
  quantity: Scalars['Int']['output'];
};


export type BookingDetailProductPriceArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type DateRange = {
  from: Scalars['Date']['input'];
  until: Scalars['Date']['input'];
};

export type Group = {
  __typename?: 'Group';
  bookings?: Maybe<Array<Booking>>;
  date: Scalars['String']['output'];
  groupedGuests?: Maybe<Array<GroupedGuests>>;
  guideAssignments?: Maybe<Array<GuideAssignment>>;
  guides?: Maybe<Array<Guide>>;
  id: Scalars['ID']['output'];
  maxPeople: Scalars['Int']['output'];
  numPeople: Scalars['Int']['output'];
  product?: Maybe<Product>;
  time: Scalars['String']['output'];
  type: GroupType;
};


export type GroupGroupedGuestsArgs = {
  includeRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GroupGuidesArgs = {
  excludeRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum GroupType {
  Ojt = 'OJT',
  Private = 'private',
  Public = 'public'
}

export type GroupVenueCost = {
  __typename?: 'GroupVenueCost';
  bookingId?: Maybe<Scalars['ID']['output']>;
  cost: Scalars['Int']['output'];
  costType: Scalars['String']['output'];
  created: Scalars['Date']['output'];
  groupVenueId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isNoShow?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  productPriceId?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type GroupedGuests = {
  __typename?: 'GroupedGuests';
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type Guide = {
  __typename?: 'Guide';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
};

export type GuideAssignment = {
  __typename?: 'GuideAssignment';
  guide?: Maybe<Guide>;
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

export type IndexRange = {
  __typename?: 'IndexRange';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  error?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteVenuePortalNotification: Scalars['Boolean']['output'];
  deleteVenuePortalUser: Array<VenuePortalUser>;
  editPassword?: Maybe<Scalars['Boolean']['output']>;
  editVenuePortalUser?: Maybe<VenuePortalUser>;
  editVenuePortalUserSettings?: Maybe<Scalars['Boolean']['output']>;
  editVenueReservationAnswer?: Maybe<Scalars['Boolean']['output']>;
  login?: Maybe<LoginResponse>;
  markVenuePortalUserNotificationsRead: Scalars['Boolean']['output'];
  requestPassword?: Maybe<Scalars['Boolean']['output']>;
  saveVenuePortalNotification: VenuePortalNotification;
  sendReservationInquiryEmail?: Maybe<Scalars['Boolean']['output']>;
  sendVenuePortalFeedbackEmail?: Maybe<Scalars['Boolean']['output']>;
  triggerVenuePortalUserPasswordReset: Scalars['String']['output'];
};


export type MutationDeleteVenuePortalNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVenuePortalUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditPasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationEditVenuePortalUserArgs = {
  childrenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  iso639_1?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationEditVenuePortalUserSettingsArgs = {
  firstDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  iso639_1?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  receiveCancelledReservationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveNewReservationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveUpdatedReservationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  venuePortalUserId: Scalars['ID']['input'];
};


export type MutationEditVenueReservationAnswerArgs = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkVenuePortalUserNotificationsReadArgs = {
  venuePortalUserId: Scalars['ID']['input'];
};


export type MutationRequestPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveVenuePortalNotificationArgs = {
  input: SaveVenuePortalNotificationInput;
};


export type MutationSendReservationInquiryEmailArgs = {
  body: Scalars['String']['input'];
  groupVenueId: Scalars['ID']['input'];
};


export type MutationSendVenuePortalFeedbackEmailArgs = {
  body: Scalars['String']['input'];
};


export type MutationTriggerVenuePortalUserPasswordResetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  id: Scalars['ID']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  venuePortalNotification: VenuePortalNotification;
  venuePortalNotifications: VenuePortalNotificationsResult;
  venuePortalPasswordRequest?: Maybe<VenuePortalPasswordRequest>;
  venuePortalUser?: Maybe<VenuePortalUser>;
  venuePortalUsers?: Maybe<VenuePortalUsersResult>;
  venueReservation?: Maybe<VenueReservation>;
};


export type QueryVenuePortalNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVenuePortalNotificationsArgs = {
  input?: InputMaybe<VenuePortalNotificationsInput>;
};


export type QueryVenuePortalPasswordRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVenuePortalUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVenuePortalUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVenueReservationArgs = {
  id: Scalars['ID']['input'];
};

export type SaveVenuePortalNotificationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<VenuePortalNotificationTranslationInput>;
  venuePortalUserIds: Array<Scalars['ID']['input']>;
};

export type Venue = {
  __typename?: 'Venue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pendingReservationsCount: Scalars['Int']['output'];
  products?: Maybe<Array<Product>>;
  reservations?: Maybe<VenueVenueReservationsResult>;
  venuePortalUsers?: Maybe<Array<VenuePortalUser>>;
};


export type VenueReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pendingFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenuePortalNotification = {
  __typename?: 'VenuePortalNotification';
  created: Scalars['DateTimeTest']['output'];
  id: Scalars['ID']['output'];
  translation?: Maybe<VenuePortalNotificationTranslation>;
  translations: Array<VenuePortalNotificationTranslation>;
  updatedAt: Scalars['DateTimeTest']['output'];
  userLinks: Array<VenuePortalNotificationUserLink>;
};


export type VenuePortalNotificationTranslationArgs = {
  iso639_1: Scalars['String']['input'];
};


export type VenuePortalNotificationTranslationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type VenuePortalNotificationUserLinksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type VenuePortalNotificationTranslation = {
  __typename?: 'VenuePortalNotificationTranslation';
  body: Scalars['String']['output'];
  created: Scalars['DateTimeTest']['output'];
  id: Scalars['ID']['output'];
  iso639_1: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeTest']['output'];
};

export type VenuePortalNotificationTranslationInput = {
  body: Scalars['String']['input'];
  iso639_1: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type VenuePortalNotificationUserLink = {
  __typename?: 'VenuePortalNotificationUserLink';
  notification: VenuePortalNotification;
  readAt?: Maybe<Scalars['DateTimeTest']['output']>;
  venuePortalNotificationId: Scalars['ID']['output'];
  venuePortalUser: VenuePortalUser;
  venuePortalUserId: Scalars['ID']['output'];
};

export type VenuePortalNotificationsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VenuePortalNotificationsResult = {
  __typename?: 'VenuePortalNotificationsResult';
  records: Array<VenuePortalNotification>;
  totalRecords: Scalars['Int']['output'];
};

export type VenuePortalPasswordRequest = {
  __typename?: 'VenuePortalPasswordRequest';
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  usedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<VenuePortalUser>;
  validUntil: Scalars['Date']['output'];
  venuePortalUserId: Scalars['ID']['output'];
};

export type VenuePortalUser = {
  __typename?: 'VenuePortalUser';
  dashboardMetrics: Array<VenuePortalUserDashboardMetric>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationLinks: Array<VenuePortalNotificationUserLink>;
  parentId?: Maybe<Scalars['ID']['output']>;
  password: Scalars['String']['output'];
  pendingReservations: Array<VenueReservation>;
  pendingReservationsCount: Scalars['Int']['output'];
  products: Array<Product>;
  reservationBounds: VenuePortalUserVenueReservationBounds;
  reservations: VenuePortalUserVenueReservationsResult;
  settings: VenuePortalUserSettings;
  venues: Array<Venue>;
};


export type VenuePortalUserDashboardMetricsArgs = {
  currentDate: Scalars['Date']['input'];
  range: DateRange;
};


export type VenuePortalUserNotificationLinksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type VenuePortalUserPendingReservationsArgs = {
  gracePeriodMs?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type VenuePortalUserPendingReservationsCountArgs = {
  gracePeriodMs?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type VenuePortalUserReservationBoundsArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type VenuePortalUserReservationsArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  range: DateRange;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

export type VenuePortalUserDashboardMetric = {
  __typename?: 'VenuePortalUserDashboardMetric';
  date: Scalars['String']['output'];
  venues: Array<VenuePortalUserDashboardVenueMetric>;
};

export type VenuePortalUserDashboardProductMetric = {
  __typename?: 'VenuePortalUserDashboardProductMetric';
  accepted: Scalars['Int']['output'];
  cancellationNoShowRevenue: Scalars['Int']['output'];
  guests: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  rejected: Scalars['Int']['output'];
  reservations: Scalars['Int']['output'];
  revenue: Scalars['Int']['output'];
  unanswered: Scalars['Int']['output'];
};

export type VenuePortalUserDashboardVenueMetric = {
  __typename?: 'VenuePortalUserDashboardVenueMetric';
  products: Array<VenuePortalUserDashboardProductMetric>;
  venueId?: Maybe<Scalars['ID']['output']>;
};

export type VenuePortalUserSettings = {
  __typename?: 'VenuePortalUserSettings';
  firstDayOfWeek: Scalars['String']['output'];
  iso639_1: Scalars['String']['output'];
  receiveCancelledReservationEmails: Scalars['Boolean']['output'];
  receiveNewReservationEmails: Scalars['Boolean']['output'];
  receiveUpdatedReservationEmails: Scalars['Boolean']['output'];
  showEmptyDates: Scalars['Boolean']['output'];
  theme: Scalars['String']['output'];
  venuePortalUserId: Scalars['ID']['output'];
};

export type VenuePortalUserVenueReservationBounds = {
  __typename?: 'VenuePortalUserVenueReservationBounds';
  earliestDate?: Maybe<Scalars['Date']['output']>;
  latestDate?: Maybe<Scalars['Date']['output']>;
};

export type VenuePortalUserVenueReservationsResult = {
  __typename?: 'VenuePortalUserVenueReservationsResult';
  records: Array<VenueReservation>;
  recordsRange: IndexRange;
  totalRecords: Scalars['Int']['output'];
  venueReservations: Array<VenueReservation>;
};

export type VenuePortalUserVenueReservationsSearchInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

export type VenuePortalUsersResult = {
  __typename?: 'VenuePortalUsersResult';
  records: Array<VenuePortalUser>;
  totalRecords: Scalars['Int']['output'];
};

export type VenueReservation = {
  __typename?: 'VenueReservation';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  additionalInfoSetAt?: Maybe<Scalars['DateTime']['output']>;
  answer?: Maybe<VenueReservationAnswer>;
  answeredBy?: Maybe<Scalars['String']['output']>;
  cancellation?: Maybe<VenueReservationCancellation>;
  cancellationCosts: Array<VenueReservationCancellationCost>;
  costs: Array<GroupVenueCost>;
  created: Scalars['DateTime']['output'];
  group?: Maybe<Group>;
  groupVenueId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  latestInquiry?: Maybe<VenueReservationInquiry>;
  numGuests: Scalars['Int']['output'];
  numGuides: Scalars['Int']['output'];
  originalReservation?: Maybe<VenueReservation>;
  originalReservationId?: Maybe<Scalars['ID']['output']>;
  reservationAnswerReceived?: Maybe<Scalars['String']['output']>;
  reservationTime?: Maybe<Scalars['String']['output']>;
  snapshot?: Maybe<VenueReservationSnapshot>;
  venue?: Maybe<Venue>;
  venuePortalUser?: Maybe<VenuePortalUser>;
};

export enum VenueReservationAnswer {
  Accepted = 'ACCEPTED',
  NotAccepted = 'NOT_ACCEPTED'
}

export type VenueReservationCancellation = {
  __typename?: 'VenueReservationCancellation';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<Venue>;
};

export type VenueReservationCancellationCost = {
  __typename?: 'VenueReservationCancellationCost';
  bookingId?: Maybe<Scalars['ID']['output']>;
  chargePercentage: Scalars['Float']['output'];
  chargedCost: Scalars['Int']['output'];
  created: Scalars['Date']['output'];
  fullCost: Scalars['Int']['output'];
  groupId: Scalars['ID']['output'];
  groupVenueId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  priceType: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  slotId: Scalars['ID']['output'];
  venueReservationCancellationId?: Maybe<Scalars['ID']['output']>;
};

export type VenueReservationInquiry = {
  __typename?: 'VenueReservationInquiry';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  venueReservationId: Scalars['ID']['output'];
};

export type VenueReservationSnapshot = {
  __typename?: 'VenueReservationSnapshot';
  bookingDetailIds: Array<Scalars['ID']['output']>;
  details?: Maybe<Array<Maybe<BookingDetail>>>;
  groupedGuests?: Maybe<Array<GroupedGuests>>;
  guide?: Maybe<Array<Guide>>;
  guideIds: Array<Scalars['ID']['output']>;
};


export type VenueReservationSnapshotGroupedGuestsArgs = {
  includeRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VenueVenueReservationsResult = {
  __typename?: 'VenueVenueReservationsResult';
  records: Array<VenueReservation>;
  totalRecords: Scalars['Int']['output'];
};

export type GetVenuePortalUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVenuePortalUsersQuery = { __typename?: 'Query', venuePortalUsers?: { __typename?: 'VenuePortalUsersResult', records: Array<{ __typename?: 'VenuePortalUser', id: string, email: string }> } | null };

export type GetVenuePortalUserDashboardMetricsQueryVariables = Exact<{
  venuePortalUserId: Scalars['ID']['input'];
  currentDate: Scalars['Date']['input'];
  range: DateRange;
}>;


export type GetVenuePortalUserDashboardMetricsQuery = { __typename?: 'Query', venuePortalUser?: { __typename?: 'VenuePortalUser', id: string, dashboardMetrics: Array<{ __typename?: 'VenuePortalUserDashboardMetric', date: string, venues: Array<{ __typename?: 'VenuePortalUserDashboardVenueMetric', venueId?: string | null, products: Array<{ __typename?: 'VenuePortalUserDashboardProductMetric', productId: string, guests: number, revenue: number, cancellationNoShowRevenue: number, reservations: number, accepted: number, rejected: number, pending: number, unanswered: number }> }> }> } | null };

export type SendVenuePortalFeedbackEmailMutationMutationVariables = Exact<{
  body: Scalars['String']['input'];
}>;


export type SendVenuePortalFeedbackEmailMutationMutation = { __typename?: 'Mutation', sendVenuePortalFeedbackEmail?: boolean | null };

export type SendReservationInquiryEmailMutationMutationVariables = Exact<{
  groupVenueId: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type SendReservationInquiryEmailMutationMutation = { __typename?: 'Mutation', sendReservationInquiryEmail?: boolean | null };

export type EditVenueReservationAnswerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  answer?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EditVenueReservationAnswerMutation = { __typename?: 'Mutation', editVenueReservationAnswer?: boolean | null };

export type GetVenuePortalUserVenueReservationBoundsQueryVariables = Exact<{
  venuePortalUserId: Scalars['ID']['input'];
  venueId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetVenuePortalUserVenueReservationBoundsQuery = { __typename?: 'Query', venuePortalUser?: { __typename?: 'VenuePortalUser', id: string, reservationBounds: { __typename?: 'VenuePortalUserVenueReservationBounds', earliestDate?: any | null, latestDate?: any | null } } | null };

export type GetVenueReservationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVenueReservationQuery = { __typename?: 'Query', venueReservation?: { __typename?: 'VenueReservation', additionalInfo?: string | null, additionalInfoSetAt?: any | null, answer?: VenueReservationAnswer | null, answeredBy?: string | null, created: any, groupVenueId: string, id: string, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, reservationTime?: string | null, cancellation?: { __typename?: 'VenueReservationCancellation', id: string, created: any, reason?: string | null } | null, cancellationCosts: Array<{ __typename?: 'VenueReservationCancellationCost', id: string, quantity: number, chargedCost: number }>, costs: Array<{ __typename?: 'GroupVenueCost', id: string, quantity: number, cost: number, isNoShow?: boolean | null }>, latestInquiry?: { __typename?: 'VenueReservationInquiry', body: string } | null, group?: { __typename?: 'Group', id: string, date: string, time: string, type: GroupType, groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, bookings?: Array<{ __typename?: 'Booking', id: string, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null }> | null }> | null, guides?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null, guideAssignments?: Array<{ __typename?: 'GuideAssignment', role: string, guide?: { __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null } | null }> | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null, venue?: { __typename?: 'Venue', id: string, name: string } | null, venuePortalUser?: { __typename?: 'VenuePortalUser', id: string } | null, originalReservation?: { __typename?: 'VenueReservation', id: string, answer?: VenueReservationAnswer | null, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, snapshot?: { __typename?: 'VenueReservationSnapshot', groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null } | null> | null, guide?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null } | null } | null } | null };

export type ReservationFieldsFragment = { __typename?: 'VenueReservation', additionalInfo?: string | null, additionalInfoSetAt?: any | null, answer?: VenueReservationAnswer | null, answeredBy?: string | null, created: any, groupVenueId: string, id: string, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, reservationTime?: string | null, cancellation?: { __typename?: 'VenueReservationCancellation', id: string, created: any, reason?: string | null } | null, cancellationCosts: Array<{ __typename?: 'VenueReservationCancellationCost', id: string, quantity: number, chargedCost: number }>, costs: Array<{ __typename?: 'GroupVenueCost', id: string, quantity: number, cost: number, isNoShow?: boolean | null }>, latestInquiry?: { __typename?: 'VenueReservationInquiry', body: string } | null, group?: { __typename?: 'Group', id: string, date: string, time: string, type: GroupType, groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, bookings?: Array<{ __typename?: 'Booking', id: string, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null }> | null }> | null, guides?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null, guideAssignments?: Array<{ __typename?: 'GuideAssignment', role: string, guide?: { __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null } | null }> | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null, venue?: { __typename?: 'Venue', id: string, name: string } | null, venuePortalUser?: { __typename?: 'VenuePortalUser', id: string } | null, originalReservation?: { __typename?: 'VenueReservation', id: string, answer?: VenueReservationAnswer | null, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, snapshot?: { __typename?: 'VenueReservationSnapshot', groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null } | null> | null, guide?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null } | null } | null };

export type GetVenuePortalUserVenueReservationsRangeQueryVariables = Exact<{
  venuePortalUserId: Scalars['ID']['input'];
  gracePeriodMs?: InputMaybe<Scalars['Int']['input']>;
  range: DateRange;
  venueId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetVenuePortalUserVenueReservationsRangeQuery = { __typename?: 'Query', venuePortalUser?: { __typename?: 'VenuePortalUser', id: string, pendingReservationsCount: number, pendingReservations: Array<{ __typename?: 'VenueReservation', additionalInfo?: string | null, additionalInfoSetAt?: any | null, answer?: VenueReservationAnswer | null, answeredBy?: string | null, created: any, groupVenueId: string, id: string, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, reservationTime?: string | null, cancellation?: { __typename?: 'VenueReservationCancellation', id: string, created: any, reason?: string | null } | null, cancellationCosts: Array<{ __typename?: 'VenueReservationCancellationCost', id: string, quantity: number, chargedCost: number }>, costs: Array<{ __typename?: 'GroupVenueCost', id: string, quantity: number, cost: number, isNoShow?: boolean | null }>, latestInquiry?: { __typename?: 'VenueReservationInquiry', body: string } | null, group?: { __typename?: 'Group', id: string, date: string, time: string, type: GroupType, groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, bookings?: Array<{ __typename?: 'Booking', id: string, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null }> | null }> | null, guides?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null, guideAssignments?: Array<{ __typename?: 'GuideAssignment', role: string, guide?: { __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null } | null }> | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null, venue?: { __typename?: 'Venue', id: string, name: string } | null, venuePortalUser?: { __typename?: 'VenuePortalUser', id: string } | null, originalReservation?: { __typename?: 'VenueReservation', id: string, answer?: VenueReservationAnswer | null, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, snapshot?: { __typename?: 'VenueReservationSnapshot', groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null } | null> | null, guide?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null } | null } | null }>, reservations: { __typename?: 'VenuePortalUserVenueReservationsResult', venueReservations: Array<{ __typename?: 'VenueReservation', additionalInfo?: string | null, additionalInfoSetAt?: any | null, answer?: VenueReservationAnswer | null, answeredBy?: string | null, created: any, groupVenueId: string, id: string, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, reservationTime?: string | null, cancellation?: { __typename?: 'VenueReservationCancellation', id: string, created: any, reason?: string | null } | null, cancellationCosts: Array<{ __typename?: 'VenueReservationCancellationCost', id: string, quantity: number, chargedCost: number }>, costs: Array<{ __typename?: 'GroupVenueCost', id: string, quantity: number, cost: number, isNoShow?: boolean | null }>, latestInquiry?: { __typename?: 'VenueReservationInquiry', body: string } | null, group?: { __typename?: 'Group', id: string, date: string, time: string, type: GroupType, groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, bookings?: Array<{ __typename?: 'Booking', id: string, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null }> | null }> | null, guides?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null, guideAssignments?: Array<{ __typename?: 'GuideAssignment', role: string, guide?: { __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null } | null }> | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null, venue?: { __typename?: 'Venue', id: string, name: string } | null, venuePortalUser?: { __typename?: 'VenuePortalUser', id: string } | null, originalReservation?: { __typename?: 'VenueReservation', id: string, answer?: VenueReservationAnswer | null, numGuests: number, numGuides: number, reservationAnswerReceived?: string | null, snapshot?: { __typename?: 'VenueReservationSnapshot', groupedGuests?: Array<{ __typename?: 'GroupedGuests', name: string, quantity: number }> | null, details?: Array<{ __typename?: 'BookingDetail', id: string, quantity: number, productPrice?: { __typename?: 'ProductPrice', id: string, name: string } | null } | null> | null, guide?: Array<{ __typename?: 'Guide', id: string, name: string, phoneNumber?: string | null, profilePic?: string | null }> | null } | null } | null }> } } | null };

export type EditVenuePortalUserSettingsMutationVariables = Exact<{
  venuePortalUserId: Scalars['ID']['input'];
  theme?: InputMaybe<Scalars['String']['input']>;
  iso639_1?: InputMaybe<Scalars['String']['input']>;
  receiveNewReservationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveUpdatedReservationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveCancelledReservationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  firstDayOfWeek?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditVenuePortalUserSettingsMutation = { __typename?: 'Mutation', editVenuePortalUserSettings?: boolean | null };

export type GetVenuePortalUserSettingsQueryVariables = Exact<{
  venuePortalUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetVenuePortalUserSettingsQuery = { __typename?: 'Query', venuePortalUser?: { __typename?: 'VenuePortalUser', id: string, settings: { __typename?: 'VenuePortalUserSettings', theme: string, iso639_1: string, receiveNewReservationEmails: boolean, receiveUpdatedReservationEmails: boolean, receiveCancelledReservationEmails: boolean, firstDayOfWeek: string } } | null };

export type EditPasswordMutationMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EditPasswordMutationMutation = { __typename?: 'Mutation', editPassword?: boolean | null };

export type LoginMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutationMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResponse', error?: string | null, jwtToken?: string | null } | null };

export type MarkVenuePortalUserNotificationsReadMutationVariables = Exact<{
  venuePortalUserId: Scalars['ID']['input'];
}>;


export type MarkVenuePortalUserNotificationsReadMutation = { __typename?: 'Mutation', markVenuePortalUserNotificationsRead: boolean };

export type RequestPasswordMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordMutationMutation = { __typename?: 'Mutation', requestPassword?: boolean | null };

export type GetPasswordRequestQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPasswordRequestQueryQuery = { __typename?: 'Query', venuePortalPasswordRequest?: { __typename?: 'VenuePortalPasswordRequest', isExpired: boolean, usedAt?: any | null, user?: { __typename?: 'VenuePortalUser', email: string, settings: { __typename?: 'VenuePortalUserSettings', iso639_1: string } } | null } | null };

export type GetVenuePortalUserNotificationsQueryVariables = Exact<{
  venuePortalUserId?: InputMaybe<Scalars['ID']['input']>;
  iso639_1: Scalars['String']['input'];
}>;


export type GetVenuePortalUserNotificationsQuery = { __typename?: 'Query', venuePortalUser?: { __typename?: 'VenuePortalUser', id: string, notificationLinks: Array<{ __typename?: 'VenuePortalNotificationUserLink', venuePortalUserId: string, venuePortalNotificationId: string, readAt?: any | null, notification: { __typename?: 'VenuePortalNotification', id: string, created: any, updatedAt: any, translation?: { __typename?: 'VenuePortalNotificationTranslation', id: string, iso639_1: string, body: string, subject: string } | null } }> } | null };

export type GetVenuePortalUserVenuesQueryVariables = Exact<{
  venuePortalUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetVenuePortalUserVenuesQuery = { __typename?: 'Query', venuePortalUser?: { __typename?: 'VenuePortalUser', id: string, products: Array<{ __typename?: 'Product', id: string, name: string }>, venues: Array<{ __typename?: 'Venue', id: string, name: string, products?: Array<{ __typename?: 'Product', id: string, name: string }> | null }> } | null };

export const ReservationFieldsFragmentDoc = gql`
    fragment ReservationFields on VenueReservation {
  additionalInfo
  additionalInfoSetAt
  answer
  answeredBy
  created
  groupVenueId
  id
  numGuests
  numGuides
  reservationAnswerReceived
  reservationTime
  cancellation {
    id
    created
    reason
  }
  cancellationCosts {
    id
    quantity
    chargedCost
  }
  costs {
    id
    quantity
    cost
    isNoShow
  }
  latestInquiry {
    body
  }
  group {
    id
    date
    time
    type
    groupedGuests(includeRoles: ["OJT Trainee"]) {
      name
      quantity
    }
    bookings {
      id
      details {
        id
        quantity
        productPrice {
          id
          name
        }
      }
    }
    guides(excludeRoles: ["OJT Trainee"]) {
      id
      name
      phoneNumber
      profilePic
    }
    guideAssignments {
      role
      guide {
        id
        name
        phoneNumber
        profilePic
      }
    }
    product {
      id
      name
    }
  }
  venue {
    id
    name
  }
  venuePortalUser {
    id
  }
  originalReservation {
    id
    answer
    numGuests
    numGuides
    reservationAnswerReceived
    snapshot {
      groupedGuests(includeRoles: ["OJT Trainee"]) {
        name
        quantity
      }
      details {
        id
        quantity
        productPrice {
          id
          name
        }
      }
      guide {
        id
        name
        phoneNumber
        profilePic
      }
    }
  }
}
    `;
export const GetVenuePortalUsersDocument = gql`
    query GetVenuePortalUsers {
  venuePortalUsers {
    records {
      id
      email
    }
  }
}
    `;

/**
 * __useGetVenuePortalUsersQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVenuePortalUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>(GetVenuePortalUsersDocument, options);
      }
export function useGetVenuePortalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>(GetVenuePortalUsersDocument, options);
        }
export function useGetVenuePortalUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>(GetVenuePortalUsersDocument, options);
        }
export type GetVenuePortalUsersQueryHookResult = ReturnType<typeof useGetVenuePortalUsersQuery>;
export type GetVenuePortalUsersLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUsersLazyQuery>;
export type GetVenuePortalUsersSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUsersSuspenseQuery>;
export type GetVenuePortalUsersQueryResult = Apollo.QueryResult<GetVenuePortalUsersQuery, GetVenuePortalUsersQueryVariables>;
export const GetVenuePortalUserDashboardMetricsDocument = gql`
    query GetVenuePortalUserDashboardMetrics($venuePortalUserId: ID!, $currentDate: Date!, $range: DateRange!) {
  venuePortalUser(id: $venuePortalUserId) {
    id
    dashboardMetrics(currentDate: $currentDate, range: $range) {
      date
      venues {
        venueId
        products {
          productId
          guests
          revenue
          cancellationNoShowRevenue
          reservations
          accepted
          rejected
          pending
          unanswered
        }
      }
    }
  }
}
    `;

/**
 * __useGetVenuePortalUserDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUserDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUserDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUserDashboardMetricsQuery({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *      currentDate: // value for 'currentDate'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetVenuePortalUserDashboardMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables> & ({ variables: GetVenuePortalUserDashboardMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables>(GetVenuePortalUserDashboardMetricsDocument, options);
      }
export function useGetVenuePortalUserDashboardMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables>(GetVenuePortalUserDashboardMetricsDocument, options);
        }
export function useGetVenuePortalUserDashboardMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables>(GetVenuePortalUserDashboardMetricsDocument, options);
        }
export type GetVenuePortalUserDashboardMetricsQueryHookResult = ReturnType<typeof useGetVenuePortalUserDashboardMetricsQuery>;
export type GetVenuePortalUserDashboardMetricsLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUserDashboardMetricsLazyQuery>;
export type GetVenuePortalUserDashboardMetricsSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUserDashboardMetricsSuspenseQuery>;
export type GetVenuePortalUserDashboardMetricsQueryResult = Apollo.QueryResult<GetVenuePortalUserDashboardMetricsQuery, GetVenuePortalUserDashboardMetricsQueryVariables>;
export const SendVenuePortalFeedbackEmailMutationDocument = gql`
    mutation SendVenuePortalFeedbackEmailMutation($body: String!) {
  sendVenuePortalFeedbackEmail(body: $body)
}
    `;
export type SendVenuePortalFeedbackEmailMutationMutationFn = Apollo.MutationFunction<SendVenuePortalFeedbackEmailMutationMutation, SendVenuePortalFeedbackEmailMutationMutationVariables>;

/**
 * __useSendVenuePortalFeedbackEmailMutationMutation__
 *
 * To run a mutation, you first call `useSendVenuePortalFeedbackEmailMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVenuePortalFeedbackEmailMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVenuePortalFeedbackEmailMutationMutation, { data, loading, error }] = useSendVenuePortalFeedbackEmailMutationMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendVenuePortalFeedbackEmailMutationMutation(baseOptions?: Apollo.MutationHookOptions<SendVenuePortalFeedbackEmailMutationMutation, SendVenuePortalFeedbackEmailMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVenuePortalFeedbackEmailMutationMutation, SendVenuePortalFeedbackEmailMutationMutationVariables>(SendVenuePortalFeedbackEmailMutationDocument, options);
      }
export type SendVenuePortalFeedbackEmailMutationMutationHookResult = ReturnType<typeof useSendVenuePortalFeedbackEmailMutationMutation>;
export type SendVenuePortalFeedbackEmailMutationMutationResult = Apollo.MutationResult<SendVenuePortalFeedbackEmailMutationMutation>;
export type SendVenuePortalFeedbackEmailMutationMutationOptions = Apollo.BaseMutationOptions<SendVenuePortalFeedbackEmailMutationMutation, SendVenuePortalFeedbackEmailMutationMutationVariables>;
export const SendReservationInquiryEmailMutationDocument = gql`
    mutation SendReservationInquiryEmailMutation($groupVenueId: ID!, $body: String!) {
  sendReservationInquiryEmail(groupVenueId: $groupVenueId, body: $body)
}
    `;
export type SendReservationInquiryEmailMutationMutationFn = Apollo.MutationFunction<SendReservationInquiryEmailMutationMutation, SendReservationInquiryEmailMutationMutationVariables>;

/**
 * __useSendReservationInquiryEmailMutationMutation__
 *
 * To run a mutation, you first call `useSendReservationInquiryEmailMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReservationInquiryEmailMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReservationInquiryEmailMutationMutation, { data, loading, error }] = useSendReservationInquiryEmailMutationMutation({
 *   variables: {
 *      groupVenueId: // value for 'groupVenueId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendReservationInquiryEmailMutationMutation(baseOptions?: Apollo.MutationHookOptions<SendReservationInquiryEmailMutationMutation, SendReservationInquiryEmailMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReservationInquiryEmailMutationMutation, SendReservationInquiryEmailMutationMutationVariables>(SendReservationInquiryEmailMutationDocument, options);
      }
export type SendReservationInquiryEmailMutationMutationHookResult = ReturnType<typeof useSendReservationInquiryEmailMutationMutation>;
export type SendReservationInquiryEmailMutationMutationResult = Apollo.MutationResult<SendReservationInquiryEmailMutationMutation>;
export type SendReservationInquiryEmailMutationMutationOptions = Apollo.BaseMutationOptions<SendReservationInquiryEmailMutationMutation, SendReservationInquiryEmailMutationMutationVariables>;
export const EditVenueReservationAnswerDocument = gql`
    mutation EditVenueReservationAnswer($id: ID!, $answer: String, $venueId: ID) {
  editVenueReservationAnswer(id: $id, answer: $answer, venueId: $venueId)
}
    `;
export type EditVenueReservationAnswerMutationFn = Apollo.MutationFunction<EditVenueReservationAnswerMutation, EditVenueReservationAnswerMutationVariables>;

/**
 * __useEditVenueReservationAnswerMutation__
 *
 * To run a mutation, you first call `useEditVenueReservationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenueReservationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenueReservationAnswerMutation, { data, loading, error }] = useEditVenueReservationAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      answer: // value for 'answer'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useEditVenueReservationAnswerMutation(baseOptions?: Apollo.MutationHookOptions<EditVenueReservationAnswerMutation, EditVenueReservationAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenueReservationAnswerMutation, EditVenueReservationAnswerMutationVariables>(EditVenueReservationAnswerDocument, options);
      }
export type EditVenueReservationAnswerMutationHookResult = ReturnType<typeof useEditVenueReservationAnswerMutation>;
export type EditVenueReservationAnswerMutationResult = Apollo.MutationResult<EditVenueReservationAnswerMutation>;
export type EditVenueReservationAnswerMutationOptions = Apollo.BaseMutationOptions<EditVenueReservationAnswerMutation, EditVenueReservationAnswerMutationVariables>;
export const GetVenuePortalUserVenueReservationBoundsDocument = gql`
    query GetVenuePortalUserVenueReservationBounds($venuePortalUserId: ID!, $venueId: ID, $productId: ID) {
  venuePortalUser(id: $venuePortalUserId) {
    id
    reservationBounds(venueId: $venueId, productId: $productId) {
      earliestDate
      latestDate
    }
  }
}
    `;

/**
 * __useGetVenuePortalUserVenueReservationBoundsQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUserVenueReservationBoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUserVenueReservationBoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUserVenueReservationBoundsQuery({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *      venueId: // value for 'venueId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetVenuePortalUserVenueReservationBoundsQuery(baseOptions: Apollo.QueryHookOptions<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables> & ({ variables: GetVenuePortalUserVenueReservationBoundsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables>(GetVenuePortalUserVenueReservationBoundsDocument, options);
      }
export function useGetVenuePortalUserVenueReservationBoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables>(GetVenuePortalUserVenueReservationBoundsDocument, options);
        }
export function useGetVenuePortalUserVenueReservationBoundsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables>(GetVenuePortalUserVenueReservationBoundsDocument, options);
        }
export type GetVenuePortalUserVenueReservationBoundsQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenueReservationBoundsQuery>;
export type GetVenuePortalUserVenueReservationBoundsLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenueReservationBoundsLazyQuery>;
export type GetVenuePortalUserVenueReservationBoundsSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenueReservationBoundsSuspenseQuery>;
export type GetVenuePortalUserVenueReservationBoundsQueryResult = Apollo.QueryResult<GetVenuePortalUserVenueReservationBoundsQuery, GetVenuePortalUserVenueReservationBoundsQueryVariables>;
export const GetVenueReservationDocument = gql`
    query GetVenueReservation($id: ID!) {
  venueReservation(id: $id) {
    ...ReservationFields
  }
}
    ${ReservationFieldsFragmentDoc}`;

/**
 * __useGetVenueReservationQuery__
 *
 * To run a query within a React component, call `useGetVenueReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueReservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVenueReservationQuery(baseOptions: Apollo.QueryHookOptions<GetVenueReservationQuery, GetVenueReservationQueryVariables> & ({ variables: GetVenueReservationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueReservationQuery, GetVenueReservationQueryVariables>(GetVenueReservationDocument, options);
      }
export function useGetVenueReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueReservationQuery, GetVenueReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueReservationQuery, GetVenueReservationQueryVariables>(GetVenueReservationDocument, options);
        }
export function useGetVenueReservationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenueReservationQuery, GetVenueReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenueReservationQuery, GetVenueReservationQueryVariables>(GetVenueReservationDocument, options);
        }
export type GetVenueReservationQueryHookResult = ReturnType<typeof useGetVenueReservationQuery>;
export type GetVenueReservationLazyQueryHookResult = ReturnType<typeof useGetVenueReservationLazyQuery>;
export type GetVenueReservationSuspenseQueryHookResult = ReturnType<typeof useGetVenueReservationSuspenseQuery>;
export type GetVenueReservationQueryResult = Apollo.QueryResult<GetVenueReservationQuery, GetVenueReservationQueryVariables>;
export const GetVenuePortalUserVenueReservationsRangeDocument = gql`
    query GetVenuePortalUserVenueReservationsRange($venuePortalUserId: ID!, $gracePeriodMs: Int, $range: DateRange!, $venueId: ID, $productId: ID) {
  venuePortalUser(id: $venuePortalUserId) {
    id
    pendingReservationsCount(
      gracePeriodMs: $gracePeriodMs
      venueId: $venueId
      productId: $productId
    )
    pendingReservations(
      gracePeriodMs: $gracePeriodMs
      venueId: $venueId
      productId: $productId
    ) {
      ...ReservationFields
    }
    reservations(range: $range, venueId: $venueId, productId: $productId) {
      venueReservations {
        ...ReservationFields
      }
    }
  }
}
    ${ReservationFieldsFragmentDoc}`;

/**
 * __useGetVenuePortalUserVenueReservationsRangeQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUserVenueReservationsRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUserVenueReservationsRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUserVenueReservationsRangeQuery({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *      gracePeriodMs: // value for 'gracePeriodMs'
 *      range: // value for 'range'
 *      venueId: // value for 'venueId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetVenuePortalUserVenueReservationsRangeQuery(baseOptions: Apollo.QueryHookOptions<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables> & ({ variables: GetVenuePortalUserVenueReservationsRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables>(GetVenuePortalUserVenueReservationsRangeDocument, options);
      }
export function useGetVenuePortalUserVenueReservationsRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables>(GetVenuePortalUserVenueReservationsRangeDocument, options);
        }
export function useGetVenuePortalUserVenueReservationsRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables>(GetVenuePortalUserVenueReservationsRangeDocument, options);
        }
export type GetVenuePortalUserVenueReservationsRangeQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenueReservationsRangeQuery>;
export type GetVenuePortalUserVenueReservationsRangeLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenueReservationsRangeLazyQuery>;
export type GetVenuePortalUserVenueReservationsRangeSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenueReservationsRangeSuspenseQuery>;
export type GetVenuePortalUserVenueReservationsRangeQueryResult = Apollo.QueryResult<GetVenuePortalUserVenueReservationsRangeQuery, GetVenuePortalUserVenueReservationsRangeQueryVariables>;
export const EditVenuePortalUserSettingsDocument = gql`
    mutation EditVenuePortalUserSettings($venuePortalUserId: ID!, $theme: String, $iso639_1: String, $receiveNewReservationEmails: Boolean, $receiveUpdatedReservationEmails: Boolean, $receiveCancelledReservationEmails: Boolean, $firstDayOfWeek: String) {
  editVenuePortalUserSettings(
    venuePortalUserId: $venuePortalUserId
    theme: $theme
    iso639_1: $iso639_1
    receiveNewReservationEmails: $receiveNewReservationEmails
    receiveUpdatedReservationEmails: $receiveUpdatedReservationEmails
    receiveCancelledReservationEmails: $receiveCancelledReservationEmails
    firstDayOfWeek: $firstDayOfWeek
  )
}
    `;
export type EditVenuePortalUserSettingsMutationFn = Apollo.MutationFunction<EditVenuePortalUserSettingsMutation, EditVenuePortalUserSettingsMutationVariables>;

/**
 * __useEditVenuePortalUserSettingsMutation__
 *
 * To run a mutation, you first call `useEditVenuePortalUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenuePortalUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenuePortalUserSettingsMutation, { data, loading, error }] = useEditVenuePortalUserSettingsMutation({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *      theme: // value for 'theme'
 *      iso639_1: // value for 'iso639_1'
 *      receiveNewReservationEmails: // value for 'receiveNewReservationEmails'
 *      receiveUpdatedReservationEmails: // value for 'receiveUpdatedReservationEmails'
 *      receiveCancelledReservationEmails: // value for 'receiveCancelledReservationEmails'
 *      firstDayOfWeek: // value for 'firstDayOfWeek'
 *   },
 * });
 */
export function useEditVenuePortalUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditVenuePortalUserSettingsMutation, EditVenuePortalUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenuePortalUserSettingsMutation, EditVenuePortalUserSettingsMutationVariables>(EditVenuePortalUserSettingsDocument, options);
      }
export type EditVenuePortalUserSettingsMutationHookResult = ReturnType<typeof useEditVenuePortalUserSettingsMutation>;
export type EditVenuePortalUserSettingsMutationResult = Apollo.MutationResult<EditVenuePortalUserSettingsMutation>;
export type EditVenuePortalUserSettingsMutationOptions = Apollo.BaseMutationOptions<EditVenuePortalUserSettingsMutation, EditVenuePortalUserSettingsMutationVariables>;
export const GetVenuePortalUserSettingsDocument = gql`
    query GetVenuePortalUserSettings($venuePortalUserId: ID) {
  venuePortalUser(id: $venuePortalUserId) {
    id
    settings {
      theme
      iso639_1
      receiveNewReservationEmails
      receiveUpdatedReservationEmails
      receiveCancelledReservationEmails
      firstDayOfWeek
    }
  }
}
    `;

/**
 * __useGetVenuePortalUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUserSettingsQuery({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *   },
 * });
 */
export function useGetVenuePortalUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>(GetVenuePortalUserSettingsDocument, options);
      }
export function useGetVenuePortalUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>(GetVenuePortalUserSettingsDocument, options);
        }
export function useGetVenuePortalUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>(GetVenuePortalUserSettingsDocument, options);
        }
export type GetVenuePortalUserSettingsQueryHookResult = ReturnType<typeof useGetVenuePortalUserSettingsQuery>;
export type GetVenuePortalUserSettingsLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUserSettingsLazyQuery>;
export type GetVenuePortalUserSettingsSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUserSettingsSuspenseQuery>;
export type GetVenuePortalUserSettingsQueryResult = Apollo.QueryResult<GetVenuePortalUserSettingsQuery, GetVenuePortalUserSettingsQueryVariables>;
export const EditPasswordMutationDocument = gql`
    mutation EditPasswordMutation($newPassword: String!, $currentPassword: String, $requestId: ID) {
  editPassword(
    newPassword: $newPassword
    currentPassword: $currentPassword
    requestId: $requestId
  )
}
    `;
export type EditPasswordMutationMutationFn = Apollo.MutationFunction<EditPasswordMutationMutation, EditPasswordMutationMutationVariables>;

/**
 * __useEditPasswordMutationMutation__
 *
 * To run a mutation, you first call `useEditPasswordMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPasswordMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPasswordMutationMutation, { data, loading, error }] = useEditPasswordMutationMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      currentPassword: // value for 'currentPassword'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useEditPasswordMutationMutation(baseOptions?: Apollo.MutationHookOptions<EditPasswordMutationMutation, EditPasswordMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPasswordMutationMutation, EditPasswordMutationMutationVariables>(EditPasswordMutationDocument, options);
      }
export type EditPasswordMutationMutationHookResult = ReturnType<typeof useEditPasswordMutationMutation>;
export type EditPasswordMutationMutationResult = Apollo.MutationResult<EditPasswordMutationMutation>;
export type EditPasswordMutationMutationOptions = Apollo.BaseMutationOptions<EditPasswordMutationMutation, EditPasswordMutationMutationVariables>;
export const LoginMutationDocument = gql`
    mutation LoginMutation($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    error
    jwtToken
  }
}
    `;
export type LoginMutationMutationFn = Apollo.MutationFunction<LoginMutationMutation, LoginMutationMutationVariables>;

/**
 * __useLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutationMutation, { data, loading, error }] = useLoginMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutationMutation, LoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutationMutation, LoginMutationMutationVariables>(LoginMutationDocument, options);
      }
export type LoginMutationMutationHookResult = ReturnType<typeof useLoginMutationMutation>;
export type LoginMutationMutationResult = Apollo.MutationResult<LoginMutationMutation>;
export type LoginMutationMutationOptions = Apollo.BaseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables>;
export const MarkVenuePortalUserNotificationsReadDocument = gql`
    mutation MarkVenuePortalUserNotificationsRead($venuePortalUserId: ID!) {
  markVenuePortalUserNotificationsRead(venuePortalUserId: $venuePortalUserId)
}
    `;
export type MarkVenuePortalUserNotificationsReadMutationFn = Apollo.MutationFunction<MarkVenuePortalUserNotificationsReadMutation, MarkVenuePortalUserNotificationsReadMutationVariables>;

/**
 * __useMarkVenuePortalUserNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkVenuePortalUserNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkVenuePortalUserNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markVenuePortalUserNotificationsReadMutation, { data, loading, error }] = useMarkVenuePortalUserNotificationsReadMutation({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *   },
 * });
 */
export function useMarkVenuePortalUserNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkVenuePortalUserNotificationsReadMutation, MarkVenuePortalUserNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkVenuePortalUserNotificationsReadMutation, MarkVenuePortalUserNotificationsReadMutationVariables>(MarkVenuePortalUserNotificationsReadDocument, options);
      }
export type MarkVenuePortalUserNotificationsReadMutationHookResult = ReturnType<typeof useMarkVenuePortalUserNotificationsReadMutation>;
export type MarkVenuePortalUserNotificationsReadMutationResult = Apollo.MutationResult<MarkVenuePortalUserNotificationsReadMutation>;
export type MarkVenuePortalUserNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkVenuePortalUserNotificationsReadMutation, MarkVenuePortalUserNotificationsReadMutationVariables>;
export const RequestPasswordMutationDocument = gql`
    mutation RequestPasswordMutation($email: String!) {
  requestPassword(email: $email)
}
    `;
export type RequestPasswordMutationMutationFn = Apollo.MutationFunction<RequestPasswordMutationMutation, RequestPasswordMutationMutationVariables>;

/**
 * __useRequestPasswordMutationMutation__
 *
 * To run a mutation, you first call `useRequestPasswordMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordMutationMutation, { data, loading, error }] = useRequestPasswordMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordMutationMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordMutationMutation, RequestPasswordMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordMutationMutation, RequestPasswordMutationMutationVariables>(RequestPasswordMutationDocument, options);
      }
export type RequestPasswordMutationMutationHookResult = ReturnType<typeof useRequestPasswordMutationMutation>;
export type RequestPasswordMutationMutationResult = Apollo.MutationResult<RequestPasswordMutationMutation>;
export type RequestPasswordMutationMutationOptions = Apollo.BaseMutationOptions<RequestPasswordMutationMutation, RequestPasswordMutationMutationVariables>;
export const GetPasswordRequestQueryDocument = gql`
    query GetPasswordRequestQuery($id: ID!) {
  venuePortalPasswordRequest(id: $id) {
    isExpired
    usedAt
    user {
      email
      settings {
        iso639_1
      }
    }
  }
}
    `;

/**
 * __useGetPasswordRequestQueryQuery__
 *
 * To run a query within a React component, call `useGetPasswordRequestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPasswordRequestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPasswordRequestQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPasswordRequestQueryQuery(baseOptions: Apollo.QueryHookOptions<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables> & ({ variables: GetPasswordRequestQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables>(GetPasswordRequestQueryDocument, options);
      }
export function useGetPasswordRequestQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables>(GetPasswordRequestQueryDocument, options);
        }
export function useGetPasswordRequestQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables>(GetPasswordRequestQueryDocument, options);
        }
export type GetPasswordRequestQueryQueryHookResult = ReturnType<typeof useGetPasswordRequestQueryQuery>;
export type GetPasswordRequestQueryLazyQueryHookResult = ReturnType<typeof useGetPasswordRequestQueryLazyQuery>;
export type GetPasswordRequestQuerySuspenseQueryHookResult = ReturnType<typeof useGetPasswordRequestQuerySuspenseQuery>;
export type GetPasswordRequestQueryQueryResult = Apollo.QueryResult<GetPasswordRequestQueryQuery, GetPasswordRequestQueryQueryVariables>;
export const GetVenuePortalUserNotificationsDocument = gql`
    query GetVenuePortalUserNotifications($venuePortalUserId: ID, $iso639_1: String!) {
  venuePortalUser(id: $venuePortalUserId) {
    id
    notificationLinks {
      venuePortalUserId
      venuePortalNotificationId
      readAt
      notification {
        id
        created
        updatedAt
        translation(iso639_1: $iso639_1) {
          id
          iso639_1
          body
          subject
        }
      }
    }
  }
}
    `;

/**
 * __useGetVenuePortalUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUserNotificationsQuery({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *      iso639_1: // value for 'iso639_1'
 *   },
 * });
 */
export function useGetVenuePortalUserNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables> & ({ variables: GetVenuePortalUserNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables>(GetVenuePortalUserNotificationsDocument, options);
      }
export function useGetVenuePortalUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables>(GetVenuePortalUserNotificationsDocument, options);
        }
export function useGetVenuePortalUserNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables>(GetVenuePortalUserNotificationsDocument, options);
        }
export type GetVenuePortalUserNotificationsQueryHookResult = ReturnType<typeof useGetVenuePortalUserNotificationsQuery>;
export type GetVenuePortalUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUserNotificationsLazyQuery>;
export type GetVenuePortalUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUserNotificationsSuspenseQuery>;
export type GetVenuePortalUserNotificationsQueryResult = Apollo.QueryResult<GetVenuePortalUserNotificationsQuery, GetVenuePortalUserNotificationsQueryVariables>;
export const GetVenuePortalUserVenuesDocument = gql`
    query GetVenuePortalUserVenues($venuePortalUserId: ID) {
  venuePortalUser(id: $venuePortalUserId) {
    id
    products {
      id
      name
    }
    venues {
      id
      name
      products {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetVenuePortalUserVenuesQuery__
 *
 * To run a query within a React component, call `useGetVenuePortalUserVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuePortalUserVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuePortalUserVenuesQuery({
 *   variables: {
 *      venuePortalUserId: // value for 'venuePortalUserId'
 *   },
 * });
 */
export function useGetVenuePortalUserVenuesQuery(baseOptions?: Apollo.QueryHookOptions<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>(GetVenuePortalUserVenuesDocument, options);
      }
export function useGetVenuePortalUserVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>(GetVenuePortalUserVenuesDocument, options);
        }
export function useGetVenuePortalUserVenuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>(GetVenuePortalUserVenuesDocument, options);
        }
export type GetVenuePortalUserVenuesQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenuesQuery>;
export type GetVenuePortalUserVenuesLazyQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenuesLazyQuery>;
export type GetVenuePortalUserVenuesSuspenseQueryHookResult = ReturnType<typeof useGetVenuePortalUserVenuesSuspenseQuery>;
export type GetVenuePortalUserVenuesQueryResult = Apollo.QueryResult<GetVenuePortalUserVenuesQuery, GetVenuePortalUserVenuesQueryVariables>;